import React, { useState } from 'react';
import { DiffLine } from '../../types';
import { UnfoldVertical } from 'lucide-react';

interface LineFoldControlProps {
  lineCount: number;
  lines: DiffLine[];
  mode: 'split' | 'unified';
  initialExpanded?: boolean;
}

export const LineFoldControl: React.FC<LineFoldControlProps> = ({
  lineCount,
  lines,
  mode,
  initialExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(initialExpanded);

  if (isExpanded) {
    return (
      <>
        {lines.map((line, idx) => (
          <tr key={`folded-line-${idx}`} className="text-slate-600 dark:text-slate-400 bg-slate-50/50 dark:bg-slate-800/30">
            <td className="py-0.5 px-2 text-right border-r border-slate-200 dark:border-slate-700/80 select-none text-slate-400">
              {line.old_lineno || line.oldLineNumber || ''}
            </td>
            {mode === 'split' ? (
              <>
                <td className="py-0.5 px-3 border-r border-slate-200 dark:border-slate-700/80 whitespace-pre-wrap">
                  {line.content}
                </td>
                <td className="py-0.5 px-2 text-right border-r border-slate-200 dark:border-slate-700/80 select-none text-slate-400">
                  {line.new_lineno || line.newLineNumber || ''}
                </td>
                <td className="py-0.5 px-3 whitespace-pre-wrap">{line.content}</td>
              </>
            ) : (
              <>
                <td className="py-0.5 px-2 text-right border-r border-slate-200 dark:border-slate-700/80 select-none text-slate-400">
                  {line.new_lineno || line.newLineNumber || ''}
                </td>
                <td className="py-0.5 px-1 text-center font-bold select-none border-r border-slate-200 dark:border-slate-700/80">
                  {' '}
                </td>
                <td className="py-0.5 px-3 whitespace-pre-wrap">{line.content}</td>
              </>
            )}
          </tr>
        ))}
      </>
    );
  }

  return (
    <tr className="bg-slate-100/80 dark:bg-slate-800/60 border-y border-slate-200 dark:border-slate-700 font-sans select-none">
      <td colSpan={4} className="py-2 px-4 text-center">
        <button
          onClick={() => setIsExpanded(true)}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 transition-colors py-1 px-3 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shadow-2xs hover:shadow-xs"
        >
          <UnfoldVertical className="w-3.5 h-3.5" />
          Expand {lineCount} unchanged lines
        </button>
      </td>
    </tr>
  );
};
